import type { PokerGameTile } from '@ps/poker-games-tile-mappers';

import type {
  HgClubInfo,
  RecentTournament,
  TableStaticData
} from '@swf/generated/types/api/v0/SwHomeGames';

export const PokerModalRoutes = {
  createClub: '/homegames/clubs/create-a-club',
  createClubSuccess: '/homegames/clubs/create-a-club-success',
  joinClub: '/homegames/clubs/join-a-club',
  createCashGame: '/homegames/create-game/cash-game',
  createCashGameSuccess: '/homegames/create-game/cash-game/success',
  createTournament: '/homegames/create-game/tournament',
  createTournamentSuccess: '/homegames/create-game/tournament/success',
  deleteGamePrompt: '/homegames/prompt/delete-game',
  membersAdminActions: '/homegames/members/admin-actions'
};

export interface GamesByClubs {
  [clubId: string]: PokerGameTile[];
}

export interface Loading {
  loaderName: string;
  isLoading: boolean;
}

export interface Games {
  activeGameIds: string[];
  recentTourns?: RecentTournament[];
  selectedGameIds: string[];
  tables?: TableStaticData[];
  tourns?: RecentTournament[];
}

export interface PageData {
  clubs: HgClubInfo[];
  games: Games;
  loading: {
    [key: string]: boolean;
  };
}

export interface NavLink {
  translation: {
    defaultMessage: string;
    id: string;
  };
  href: string;
}

export type InviteLink = 'JOIN_CLUB';

export enum ClubRoute {
  Announcements = 'announcements',
  Lobby = 'lobby',
  Results = 'results',
  Members = 'members',
  Settings = 'settings'
}

export enum MemberRoute {
  List = 'list',
  Pending = 'pending',
  Blocked = 'blocked'
}

export enum UserClubRole {
  Member,
  Manager,
  Admin,
  ShadowFounder,
  Observer,
  Confirmation,
  Guest,
  Suspended
}

export enum ClubPlayerStatus {
  APPROVED = 'HG_MEMBERSHIP_STATUS_APPROVED',
  APPLIED = 'HG_MEMBERSHIP_STATUS_APPLIED',
  REJECTED = 'HG_MEMBERSHIP_STATUS_REJECTED',
  BLOCKED = 'HG_MEMBERSHIP_STATUS_BLOCKED',
  SUSPENDED = 'HG_MEMBERSHIP_STATUS_SUSPENDED',
  RESIGNED = 'HG_MEMBERSHIP_STATUS_RESIGNED',
  GUEST = 'HG_MEMBERSHIP_STATUS_GUEST',
  BANNED = 'HG_MEMBERSHIP_STATUS_BANNED'
}

export enum ClubPlayerRole {
  MEMBER = 'HG_MEMBER_ROLE_MEMBER',
  FOUNDER = 'HG_MEMBER_ROLE_FOUNDER',
  ADMIN = 'HG_MEMBER_ROLE_ADMIN',
  SHADOW_FOUNDER = 'HG_MEMBER_ROLE_SHADOW_FOUNDER',
  OBSERVER = 'HG_MEMBER_ROLE_OBSERVER',
  APPLIED = 'HG_MEMBER_ROLE_APPLIED',
  GUEST = 'HG_MEMBER_ROLE_GUEST',
  SUSPENDED = 'HG_MEMBER_ROLE_SUSPENDED'
}

export enum GameType {
  'Cash Game',
  'Tournament'
}

export enum TileType {
  Cash = 'Cash',
  Upcoming = 'Upcoming',
  Scheduled = 'Scheduled',
  Recent = 'Recent'
}
